import { ElMessage } from 'element-plus'
import { useUserStoreWithOut } from '@/store/modules/user'
import encrypt from '@/utils/encrypt'
import { shouldInvalidateSession } from '@/utils/authFailurePolicy.cjs'
const changeOrigin = window.fetch;
const VUE_APP_TDS_SERVER = process.env.VUE_APP_TDS_SERVER;

window.fetch = (url, options = {}) => {
  const userStore = useUserStoreWithOut();
  const token = localStorage.getItem('token')
  options.headers = options?.headers || {}
  if (!options.headers['Content-Type'] && !(options.body instanceof FormData)) {
    options.headers['Content-Type'] = 'application/json'
  }
  if (!options.headers['Authorization'] && token && !options.ignoreToken) {
    options.headers['Authorization'] = `${token}`
    options.headers['x-access-token'] = `${token}`
  }

  if (userStore.userInfo?.loginTenantId) {
    options.headers['X-Tenant-Id'] = encrypt(userStore.userInfo.loginTenantId)
  }
  if (options.method === 'POST' || options.method === 'PUT' || options.method === 'DELETE' ) {
    options.body = typeof options.body === 'string' || options.body instanceof FormData ? options.body : JSON.stringify(options.body)
  }

  return changeOrigin(url, options)
}


export const tdsFetch = (url, options) => {
  const baseUrl = VUE_APP_TDS_SERVER;
  const userStore = useUserStoreWithOut();

  return new Promise((resolve, reject) => {
    fetch(options.joinPrefix === false ? url : baseUrl + url, options)
    .then(response => {
      if (response.status === 401 && shouldInvalidateSession(options)) {
        userStore.setToken(undefined)
        userStore.logout();
        reject()
        return
      }
      if (response.status === 401) {
        reject(new Error('认证失败'))
        return
      }
      if (response.ok) {
        if (options.responseType === 'blob') {
          response.blob().then(res => {
            resolve(res)
          })
        } else {
          response.json().then(res => {
            if (res.code === 401 && shouldInvalidateSession(options)) {
              userStore.setToken(undefined)
              userStore.logout();
              reject()
            } else if (res.code === 401) {
              reject(new Error(res.message || '认证失败'))
            } else if (options.raw) {
              // raw 模式：返回完整响应体（含 500/510 业务失败），由调用方统一提示，避免重复弹窗
              resolve(res)
            } else if (res.code === 500 || res.code === 510) {
              res.message && ElMessage.warning(res.message)
              resolve()
            } else {
              resolve(res.result)
            }
          })
        }
      } else {
        // 非 2xx 且非 401：必须 settle，否则调用方的 loading 永远不解除
        reject(new Error(`请求失败（HTTP ${response.status}）`))
      }
    })
    .catch((err) => {
      if (err.name === 'AbortError') {
        resolve({ AbortError: true })
      } else {
        reject()
        ElMessage.error('接口连接异常')
      }
    })
  })
}

export const thirdPartyFetch = (url, options = {}) => {
  options.headers = { ...options.headers, 'Content-Type': 'application/json' };
  const userStore = useUserStoreWithOut();
  const token = localStorage.getItem('token')
  options.headers = options?.headers || {}
  if (!options.headers['Content-Type'] && !(options.body instanceof FormData)) {
    options.headers['Content-Type'] = 'application/json'
  }
  if (!options.headers['Authorization'] && token && !options.ignoreToken) {
    options.headers['Authorization'] = `${token}`
    options.headers['x-access-token'] = `${token}`
  }

  if (userStore.userInfo?.loginTenantId) {
    options.headers['X-Tenant-Id'] = encrypt(userStore.userInfo.loginTenantId)
  }
  if (options.method === 'POST' || options.method === 'PUT' || options.method === 'DELETE' ) {
    options.body = typeof options.body === 'string' || options.body instanceof FormData ? options.body : JSON.stringify(options.body)
  }
  return new Promise((resolve, reject) => {
    changeOrigin(url, options)
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => {
            throw new Error(err.msg || `HTTP error! status: ${response.status}`);
          });
        }
        if (options.responseType === 'blob') {
          return response.blob();
        }
        return response.json();
      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        // console.error('第三方接口请求失败:', error);
        ElMessage.error('查新接口异常')
        reject(error);
      });
  });
}


export const tdPDF = (url, options) => {
  const baseUrl = VUE_APP_TDS_SERVER;
  const userStore = useUserStoreWithOut();

  return new Promise((resolve, reject) => {
    fetch(options.joinPrefix === false ? url : baseUrl + url, options)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          
          // 直接返回数组缓冲区
          return response.arrayBuffer();
        })
        .then(arrayBuffer => {
          resolve(arrayBuffer);
        })
        .catch((err) => {
          console.error('PDF获取失败:', err);
          ElMessage.error('PDF获取失败: ' + (err.message || '未知错误'));
          reject(err);
        })
  })
}

export const jsonToQuery = (json) => {
  let str = '';
  Object.keys(json).forEach((k, i) => {
    const val = typeof json[k] === 'string' ? json[k].trim() : json[k]
    str += val ? `${i === 0 ? '?' : '&'}${k}=${val}` : ''
  })
  return str
}
